import { Capacitor } from '@capacitor/core'
import { CircularProgress } from '@mui/material'
import PullToRefresh from 'react-simple-pull-to-refresh'

export function Refresh(props: { children: React.ReactNode; refetch: () => Promise<any> }) {
  return (
    <PullToRefresh
      onRefresh={props.refetch}
      pullingContent={<RefreshContent />}
      backgroundColor="white"
      className="min-h-screen lg:min-h-full"
      isPullable={Capacitor.isNativePlatform()}
      refreshingContent={<RefreshContent />}
    >
      <>{props.children}</>
    </PullToRefresh>
  )
}

function RefreshContent() {
  return (
    <div className="w-full grid place-items-center">
      <CircularProgress size={22} className="text-brand-700" />
    </div>
  )
}
